module.exports = __webpack_public_path__ + "static/media/zoomIn-light.90ee9bd7.svg";